function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.458824 23.1982V24.8446H47.5412V23.1982H0.458824ZM21.4772 24.3671C21.4772 24.4409 21.4156 24.5017 21.3407 24.5017H18.6928C18.6179 24.5017 18.5563 24.4409 18.5563 24.3671V23.6766C18.5563 23.6028 18.6179 23.5421 18.6928 23.5421H21.3407C21.4156 23.5421 21.4772 23.6028 21.4772 23.6766V24.3671ZM29.4446 24.3671C29.4446 24.4409 29.383 24.5017 29.3081 24.5017H26.6602C26.5854 24.5017 26.5238 24.4409 26.5238 24.3671V23.6766C26.5238 23.6028 26.5854 23.5421 26.6602 23.5421H29.3081C29.383 23.5421 29.4446 23.6028 29.4446 23.6766V24.3671Z",
  fill: "#CFD1D3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.6814 0.155518H0.354576V23.1413H47.6814V0.155518Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2556 0.155518H0.318565V11.6423H14.2556V0.155518Z",
  fill: "#84868E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.65987 10.7865C10.2433 10.7678 12.3223 8.68789 12.3034 6.14086C12.2844 3.59384 10.1748 1.5442 7.59129 1.56287C5.00782 1.58154 2.92886 3.66145 2.9478 6.20848C2.96673 8.7555 5.0764 10.8051 7.65987 10.7865Z",
  fill: "#CFD1D3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.62554 1.59191C10.1929 1.59191 12.275 3.64373 12.275 6.17486C12.275 8.706 10.1938 10.7578 7.62554 10.7578C5.05724 10.7578 2.97606 8.706 2.97606 6.17486C2.97606 3.64373 5.05724 1.59191 7.62554 1.59191ZM7.62554 1.53491C5.02975 1.53491 2.91825 3.61663 2.91825 6.17486C2.91825 8.73309 5.02975 10.8148 7.62554 10.8148C10.2213 10.8148 12.3328 8.73309 12.3328 6.17486C12.3328 3.61663 10.2213 1.53491 7.62554 1.53491Z",
  fill: "#606770"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.66157 10.6005C10.1419 10.5813 12.1369 8.58381 12.1174 6.13897C12.0979 3.69412 10.0714 1.72776 7.59104 1.74696C5.11069 1.76617 3.11576 3.76368 3.13523 6.20852C3.15471 8.65337 5.18122 10.6197 7.66157 10.6005Z",
  fill: "#A0A1A7"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M7.62556 1.77697C10.0858 1.77697 12.0874 3.7503 12.0874 6.17492C12.0874 8.59954 10.0858 10.5729 7.62556 10.5729C5.1653 10.5729 3.16373 8.59954 3.16373 6.17492C3.16373 3.7503 5.1653 1.77697 7.62556 1.77697ZM7.62556 1.71997C5.12929 1.71997 3.10592 3.71479 3.10592 6.17585C3.10592 8.63691 5.12929 10.6317 7.62556 10.6317C10.1218 10.6317 12.1452 8.63691 12.1452 6.17585C12.1452 3.71479 10.1218 1.71997 7.62556 1.71997Z",
  fill: "#606770"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.36024 1.9626L6.29864 1.96634C6.1091 2.00465 5.97736 2.16536 5.99253 2.3569L6.00295 2.41763L5.99916 2.41389L6.64645 4.90205L6.6673 4.95624C6.7308 5.08518 6.80472 5.1347 6.94308 5.17021L7.00468 5.17394V5.17768H8.24808V5.17394L8.30968 5.17021C8.42341 5.14685 8.54472 5.06743 8.58547 4.95624L8.60632 4.89831L8.61011 4.90205L9.25076 2.41389L9.26119 2.35596C9.2754 2.16536 9.14367 2.00372 8.95508 1.96541L8.89348 1.96167H8.89063H6.35929H6.36214L6.36024 1.9626Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M7.62543 7.0455C8.11116 7.0455 8.50491 6.65772 8.50491 6.17937C8.50491 5.70102 8.11116 5.31323 7.62543 5.31323C7.13971 5.31323 6.74596 5.70102 6.74596 6.17937C6.74596 6.65772 7.13971 7.0455 7.62543 7.0455Z",
  fill: "#606770",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M4.29802 9.0796L4.32834 9.13286C4.44586 9.28423 4.64962 9.33094 4.81831 9.23564L4.86949 9.20013L4.86759 9.20481L6.85968 7.54822L6.90043 7.50617C6.99047 7.39405 7.00373 7.30716 6.97625 7.16887L6.95256 7.11281L6.9554 7.11094L6.4152 6.00748L6.41236 6.00935L6.38203 5.95609C6.31096 5.86546 6.18586 5.79165 6.06645 5.80473L6.00485 5.81127L6.00674 5.8066L3.45455 6.31956L3.39769 6.33544C3.21668 6.40551 3.12759 6.59238 3.17403 6.77738L3.19772 6.83344V6.83625L4.29991 9.08334V9.08054L4.29802 9.0796Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9529 9.0796L10.9225 9.13286C10.805 9.28423 10.6012 9.33094 10.4326 9.23564L10.3814 9.20013L10.3833 9.20481L8.39119 7.54822L8.35043 7.50617C8.2604 7.39405 8.24713 7.30716 8.27462 7.16887L8.29831 7.11281L8.29547 7.11094L8.83566 6.00748L8.83851 6.00935L8.86883 5.95609C8.93991 5.86546 9.06501 5.79165 9.18442 5.80473L9.24602 5.81127L9.24413 5.8066L11.7963 6.31956L11.8532 6.33544C12.0342 6.40551 12.1233 6.59238 12.0768 6.77738L12.0531 6.83344V6.83625L10.951 9.08334V9.08054L10.9529 9.0796Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M3.1854 6.7229H0.652161V11.2984H3.1854V6.7229Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M3.1854 6.25482V6.24921C3.18161 6.08944 3.13233 5.93621 3.02618 5.84091L3.01955 5.83437C2.73903 5.58116 2.395 5.44194 2.0453 5.44288H1.79131C1.44161 5.44288 1.09853 5.58116 0.817064 5.83437L0.81043 5.84091C0.705234 5.93621 0.655953 6.08944 0.651215 6.24921V6.26323V6.72106H3.18445V6.25482H3.1854Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5858 1.15527H3.03282C2.09458 1.15527 1.32693 1.91209 1.32693 2.83709V7.26868C1.32693 8.19368 1.76952 8.9505 2.31161 8.9505H3.29628",
  stroke: "#AC6C32",
  strokeWidth: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6312 1.70752H4.02507C3.08683 1.70752 2.31918 2.46434 2.31918 3.38934V5.39444",
  stroke: "#AC6C32",
  strokeWidth: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64882 7.3584H3.20719C3.1695 7.3584 3.13895 7.38852 3.13895 7.42567V9.2056C3.13895 9.24275 3.1695 9.27287 3.20719 9.27287H3.64882C3.68651 9.27287 3.71706 9.24275 3.71706 9.2056V7.42567C3.71706 7.38852 3.68651 7.3584 3.64882 7.3584Z",
  fill: "#C6C9CB"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64882 7.3584H3.20719C3.1695 7.3584 3.13895 7.38852 3.13895 7.42567V9.2056C3.13895 9.24275 3.1695 9.27287 3.20719 9.27287H3.64882C3.68651 9.27287 3.71706 9.24275 3.71706 9.2056V7.42567C3.71706 7.38852 3.68651 7.3584 3.64882 7.3584Z",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7593 10.2866H9.9549C9.69843 10.2866 9.49052 10.4914 9.49052 10.744C9.49052 10.9966 9.69843 11.2013 9.9549 11.2013H11.7593C12.0158 11.2013 12.2237 10.9966 12.2237 10.744C12.2237 10.4914 12.0158 10.2866 11.7593 10.2866Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2556 11.2424H0.318565V11.6423H14.2556V11.2424Z",
  fill: "#434244",
  stroke: "#434244",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M3.0186 0.548828V11.248",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M5.3604 0.548828V11.248",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M7.70219 0.548828V11.248",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M10.044 0.548828V11.248",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 1.04028H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 1.3103H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 1.58032H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 1.85034H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 2.11938H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 2.3894H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 2.65942H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 2.92944H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 3.19946H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 3.46948H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 3.7395H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 4.00879H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 4.27881H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 4.54883H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 4.81885H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 5.08887H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 5.35889H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 5.62891H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 5.89795H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 6.16797H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 6.43799H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 6.70801H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 6.97803H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 7.24805H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 7.51807H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 7.78711H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 8.05713H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 8.32715H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 8.59717H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 8.86719H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 9.13721H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 9.40649H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 9.67651H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 9.94653H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 10.2166H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 10.4866H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 10.7566H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 0.770264H12.4161",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 11.0266H12.4161",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2556 11.6208H0.318565V23.1077H14.2556V11.6208Z",
  fill: "#84868E"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M7.66172 22.2503C10.2452 22.2317 12.3241 20.1518 12.3052 17.6047C12.2863 15.0577 10.1766 13.0081 7.59314 13.0267C5.00967 13.0454 2.9307 15.1253 2.94964 17.6723C2.96858 20.2194 5.07825 22.269 7.66172 22.2503Z",
  fill: "#CFD1D3"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M7.62549 13.057C10.1928 13.057 12.275 15.1088 12.275 17.6399C12.275 20.1711 10.1938 22.2229 7.62549 22.2229C5.05719 22.2229 2.97602 20.1711 2.97602 17.6399C2.97602 15.1088 5.05719 13.057 7.62549 13.057ZM7.62549 13C5.02971 13 2.91821 15.0817 2.91821 17.6399C2.91821 20.1982 5.02971 22.2799 7.62549 22.2799C10.2213 22.2799 12.3328 20.1982 12.3328 17.6399C12.3328 15.0817 10.2213 13 7.62549 13Z",
  fill: "#606770"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M7.66393 22.0673C10.1443 22.046 12.1374 20.0467 12.1158 17.6019C12.0941 15.1571 10.0659 13.1925 7.58557 13.2138C5.10523 13.2351 3.11207 15.2344 3.13371 17.6792C3.15535 20.124 5.1836 22.0886 7.66393 22.0673Z",
  fill: "#A0A1A7"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M7.62525 13.2416C10.0855 13.2416 12.0871 15.2149 12.0871 17.6395C12.0871 20.0641 10.0855 22.0375 7.62525 22.0375C5.16499 22.0375 3.16342 20.0641 3.16342 17.6395C3.16342 15.2149 5.16499 13.2416 7.62525 13.2416ZM7.62525 13.1846C5.12897 13.1846 3.10561 15.1794 3.10561 17.6405C3.10561 20.1015 5.12897 22.0963 7.62525 22.0963C10.1215 22.0963 12.1449 20.1015 12.1449 17.6405C12.1449 15.1794 10.1215 13.1846 7.62525 13.1846Z",
  fill: "#606770"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M6.36023 13.4277L6.29863 13.4314C6.10909 13.4697 5.97736 13.6304 5.99252 13.822L6.00294 13.8827L5.99915 13.879L6.64644 16.3671L6.66729 16.4213C6.73079 16.5503 6.80471 16.5998 6.94307 16.6353L7.00468 16.639V16.6428H8.24807V16.639L8.30968 16.6353C8.4234 16.6119 8.54471 16.5325 8.58546 16.4213L8.60631 16.3634L8.6101 16.3671L9.25075 13.879L9.26118 13.8211C9.27539 13.6304 9.14366 13.4688 8.95507 13.4305L8.89347 13.4268H8.89062H6.35928H6.36213L6.36023 13.4277Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M7.62543 18.5106C8.11115 18.5106 8.5049 18.1228 8.5049 17.6445C8.5049 17.1661 8.11115 16.7783 7.62543 16.7783C7.1397 16.7783 6.74595 17.1661 6.74595 17.6445C6.74595 18.1228 7.1397 18.5106 7.62543 18.5106Z",
  fill: "#606770",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M4.29801 20.5447L4.32833 20.598C4.44585 20.7493 4.64961 20.796 4.8183 20.7007L4.86948 20.6652L4.86758 20.6699L6.85967 19.0133L6.90043 18.9713C6.99046 18.8591 7.00373 18.7722 6.97624 18.634L6.95255 18.5779L6.95539 18.576L6.4152 17.4726L6.41235 17.4744L6.38203 17.4212C6.31095 17.3306 6.18585 17.2567 6.06644 17.2698L6.00484 17.2764L6.00673 17.2717L3.45454 17.7846L3.39768 17.8005C3.21667 17.8706 3.12758 18.0575 3.17402 18.2425L3.19771 18.2985V18.3013L4.2999 20.5484V20.5456L4.29801 20.5447Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9528 20.5447L10.9225 20.598C10.805 20.7493 10.6012 20.796 10.4325 20.7007L10.3814 20.6652L10.3833 20.6699L8.39118 19.0133L8.35043 18.9713C8.26039 18.8591 8.24713 18.7722 8.27461 18.634L8.2983 18.5779L8.29546 18.576L8.83565 17.4726L8.8385 17.4744L8.86882 17.4212C8.9399 17.3306 9.065 17.2567 9.18441 17.2698L9.24601 17.2764L9.24412 17.2717L11.7963 17.7846L11.8532 17.8005C12.0342 17.8706 12.1233 18.0575 12.0768 18.2425L12.0531 18.2985V18.3013L10.9509 20.5484V20.5456L10.9528 20.5447Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M3.1854 18.1873H0.652161V22.7627H3.1854V18.1873Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M3.1854 17.7202V17.7145C3.18161 17.5548 3.13233 17.4015 3.02618 17.3062L3.01955 17.2997C2.73903 17.0465 2.395 16.9073 2.0453 16.9082H1.79131C1.44161 16.9082 1.09853 17.0465 0.817064 17.2997L0.81043 17.3062C0.705234 17.4015 0.655953 17.5548 0.651215 17.7145V17.7286V18.1864H3.18445V17.7202H3.1854Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5858 12.6206H3.03282C2.09458 12.6206 1.32693 13.3774 1.32693 14.3024V18.734C1.32693 19.659 1.76952 20.4158 2.31161 20.4158H3.29628",
  stroke: "#AC6C32",
  strokeWidth: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6312 13.1719H4.02507C3.08683 13.1719 2.31918 13.9287 2.31918 14.8537V16.8588",
  stroke: "#AC6C32",
  strokeWidth: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64882 18.8228H3.20719C3.1695 18.8228 3.13895 18.8529 3.13895 18.89V20.6699C3.13895 20.7071 3.1695 20.7372 3.20719 20.7372H3.64882C3.68651 20.7372 3.71706 20.7071 3.71706 20.6699V18.89C3.71706 18.8529 3.68651 18.8228 3.64882 18.8228Z",
  fill: "#C6C9CB"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64882 18.8228H3.20719C3.1695 18.8228 3.13895 18.8529 3.13895 18.89V20.6699C3.13895 20.7071 3.1695 20.7372 3.20719 20.7372H3.64882C3.68651 20.7372 3.71706 20.7071 3.71706 20.6699V18.89C3.71706 18.8529 3.68651 18.8228 3.64882 18.8228Z",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M9.9549 21.752H11.7593C12.0152 21.752 12.2237 21.9566 12.2237 22.2098C12.2237 22.4621 12.0162 22.6676 11.7593 22.6676H9.9549C9.69902 22.6676 9.49052 22.463 9.49052 22.2098C9.49052 21.9575 9.69807 21.752 9.9549 21.752Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2556 22.7068H0.318565V23.1067H14.2556V22.7068Z",
  fill: "#434244",
  stroke: "#434244",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M3.0186 12.0142V22.7133",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M5.3604 12.0142V22.7133",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M7.70219 12.0142V22.7133",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M10.044 12.0142V22.7133",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 12.5056H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 12.7756H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 13.0447H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 13.3147H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 13.5847H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 13.8547H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 14.1248H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 14.3948H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 14.6648H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 14.9341H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 15.2041H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 15.4741H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 15.7441H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 16.0142H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 16.2842H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 16.5532H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 16.8232H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 17.0933H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 17.3633H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 17.6333H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 17.9033H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 18.1733H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 18.4424H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 18.7124H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 18.9824H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 19.2524H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 19.5225H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 19.7925H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 20.0625H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 20.3318H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 20.6018H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 20.8718H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 21.1418H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 21.4119H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 21.6819H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 21.9509H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 22.2209H12.3953",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 12.2356H12.4161",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M0.647423 22.491H12.4161",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2556 11.6208H0.318565V12.0077H14.2556V11.6208Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4452 0.190186H12.4436V23.1414H14.4452V0.190186Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M47.4559 0.155518H33.5198V11.6423H47.4559V0.155518Z",
  fill: "#84868E"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8257 10.7866C38.246 10.7866 36.1478 8.71795 36.1478 6.17466C36.1478 3.63138 38.246 1.56274 40.8257 1.56274C43.4054 1.56274 45.5036 3.63138 45.5036 6.17466C45.5036 8.71795 43.4054 10.7866 40.8257 10.7866Z",
  fill: "#CFD1D3"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8257 1.59166C43.393 1.59166 45.4752 3.64348 45.4752 6.17462C45.4752 8.70575 43.394 10.7576 40.8257 10.7576C38.2574 10.7576 36.1762 8.70575 36.1762 6.17462C36.1762 3.64348 38.2574 1.59166 40.8257 1.59166ZM40.8257 1.53467C38.2299 1.53467 36.1184 3.61639 36.1184 6.17462C36.1184 8.73285 38.2299 10.8146 40.8257 10.8146C43.4215 10.8146 45.533 8.73285 45.533 6.17462C45.533 3.61639 43.4215 1.53467 40.8257 1.53467Z",
  fill: "#606770"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8257 10.6016C43.3061 10.6016 45.3169 8.61964 45.3169 6.17472C45.3169 3.7298 43.3061 1.7478 40.8257 1.7478C38.3453 1.7478 36.3345 3.7298 36.3345 6.17472C36.3345 8.61964 38.3453 10.6016 40.8257 10.6016Z",
  fill: "#A0A1A7"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8257 1.77672C43.2859 1.77672 45.2875 3.75005 45.2875 6.17468C45.2875 8.5993 43.2859 10.5726 40.8257 10.5726C38.3654 10.5726 36.3639 8.5993 36.3639 6.17468C36.3639 3.75005 38.3654 1.77672 40.8257 1.77672ZM40.8257 1.71973C38.3294 1.71973 36.306 3.71455 36.306 6.17561C36.306 8.63667 38.3294 10.6315 40.8257 10.6315C43.322 10.6315 45.3453 8.63667 45.3453 6.17561C45.3453 3.71455 43.322 1.71973 40.8257 1.71973Z",
  fill: "#606770"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5605 1.9626L39.4989 1.96634C39.3094 2.00465 39.1776 2.16536 39.1928 2.3569L39.2032 2.41763L39.1994 2.41389L39.8467 4.90205L39.8676 4.95624C39.9311 5.08518 40.005 5.1347 40.1433 5.17021L40.2049 5.17394V5.17768H41.4483V5.17394L41.5099 5.17021C41.6237 5.14685 41.745 5.06743 41.7857 4.95624L41.8066 4.89831L41.8104 4.90205L42.451 2.41389L42.4614 2.35596C42.4757 2.16536 42.3439 2.00372 42.1553 1.96541L42.0937 1.96167H42.0909H39.5595H39.5624L39.5605 1.9626Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8257 7.0455C41.3114 7.0455 41.7052 6.65772 41.7052 6.17937C41.7052 5.70102 41.3114 5.31323 40.8257 5.31323C40.34 5.31323 39.9462 5.70102 39.9462 6.17937C39.9462 6.65772 40.34 7.0455 40.8257 7.0455Z",
  fill: "#606770",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M37.4983 9.0796L37.5286 9.13286C37.6461 9.28423 37.8499 9.33094 38.0186 9.23564L38.0697 9.20013L38.0678 9.20481L40.0599 7.54822L40.1007 7.50617C40.1907 7.39405 40.204 7.30716 40.1765 7.16887L40.1528 7.11281L40.1557 7.11094L39.6155 6.00748L39.6126 6.00935L39.5823 5.95609C39.5112 5.86546 39.3861 5.79165 39.2667 5.80473L39.2051 5.81127L39.207 5.8066L36.6558 6.31956L36.5989 6.33544C36.4179 6.40551 36.3288 6.59238 36.3752 6.77738L36.3989 6.83344V6.83625L37.5011 9.08334V9.08054L37.4983 9.0796Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1531 9.0796L44.1228 9.13286C44.0053 9.28423 43.8015 9.33094 43.6328 9.23564L43.5816 9.20013L43.5835 9.20481L41.5914 7.54822L41.5507 7.50617C41.4607 7.39405 41.4474 7.30716 41.4749 7.16887L41.4986 7.11281L41.4957 7.11094L42.0359 6.00748L42.0388 6.00935L42.0691 5.95609C42.1402 5.86546 42.2653 5.79165 42.3847 5.80473L42.4463 5.81127L42.4444 5.8066L44.9956 6.31956L45.0525 6.33544C45.2335 6.40551 45.3226 6.59238 45.2761 6.77738L45.2525 6.83344V6.83625L44.1503 9.08334V9.08054L44.1531 9.0796Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3866 6.7229H33.8534V11.2984H36.3866V6.7229Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3866 6.25482V6.24921C36.3828 6.08944 36.3335 5.93621 36.2274 5.84091L36.2208 5.83437C35.9402 5.58116 35.5962 5.44194 35.2465 5.44288H34.9925C34.6428 5.44288 34.2997 5.58116 34.0183 5.83437L34.0116 5.84091C33.9064 5.93621 33.8572 6.08944 33.8524 6.24921V6.26323V6.72106H36.3857V6.25482H36.3866Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M45.787 1.15527H36.234C35.2958 1.15527 34.5281 1.91209 34.5281 2.83709V7.26868C34.5281 8.19368 34.9707 8.9505 35.5128 8.9505H36.4975",
  stroke: "#AC6C32",
  strokeWidth: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M45.8315 1.70752H37.2253C36.2871 1.70752 35.5194 2.46434 35.5194 3.38934V5.39444",
  stroke: "#AC6C32",
  strokeWidth: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8491 7.3584H36.4075C36.3698 7.3584 36.3392 7.38852 36.3392 7.42567V9.2056C36.3392 9.24275 36.3698 9.27287 36.4075 9.27287H36.8491C36.8868 9.27287 36.9173 9.24275 36.9173 9.2056V7.42567C36.9173 7.38852 36.8868 7.3584 36.8491 7.3584Z",
  fill: "#C6C9CB"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8491 7.3584H36.4075C36.3698 7.3584 36.3392 7.38852 36.3392 7.42567V9.2056C36.3392 9.24275 36.3698 9.27287 36.4075 9.27287H36.8491C36.8868 9.27287 36.9173 9.24275 36.9173 9.2056V7.42567C36.9173 7.38852 36.8868 7.3584 36.8491 7.3584Z",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9596 10.2866H43.1552C42.8987 10.2866 42.6908 10.4914 42.6908 10.744C42.6908 10.9966 42.8987 11.2013 43.1552 11.2013H44.9596C45.2161 11.2013 45.424 10.9966 45.424 10.744C45.424 10.4914 45.2161 10.2866 44.9596 10.2866Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M47.4559 11.2424H33.5198V11.6423H47.4559V11.2424Z",
  fill: "#434244",
  stroke: "#434244",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M36.2198 0.548828V11.248",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M38.5616 0.548828V11.248",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M40.9034 0.548828V11.248",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M43.2452 0.548828V11.248",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 1.04028H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 1.3103H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 1.58032H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 1.85034H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 2.11938H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 2.3894H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 2.65942H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 2.92944H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 3.19946H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 3.46948H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 3.7395H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 4.00879H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 4.27881H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 4.54883H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 4.81885H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 5.08887H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 5.35889H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 5.62891H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 5.89795H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 6.16797H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 6.43799H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 6.70801H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 6.97803H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 7.24805H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 7.51807H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 7.78711H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 8.05713H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 8.32715H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 8.59717H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 8.86719H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 9.13721H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 9.40649H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 9.67651H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 9.94653H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 10.2166H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 10.4866H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 10.7566H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 0.770264H45.6164",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 11.0266H45.6164",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "M47.4559 11.6208H33.5198V23.1077H47.4559V11.6208Z",
  fill: "#84868E"
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8257 22.2509C38.246 22.2509 36.1478 20.1823 36.1478 17.639C36.1478 15.0957 38.246 13.0271 40.8257 13.0271C43.4054 13.0271 45.5036 15.0957 45.5036 17.639C45.5036 20.1823 43.4054 22.2509 40.8257 22.2509Z",
  fill: "#CFD1D3"
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8257 13.057C43.393 13.057 45.4752 15.1088 45.4752 17.6399C45.4752 20.1711 43.394 22.2229 40.8257 22.2229C38.2574 22.2229 36.1762 20.1711 36.1762 17.6399C36.1762 15.1088 38.2574 13.057 40.8257 13.057ZM40.8257 13C38.2299 13 36.1184 15.0817 36.1184 17.6399C36.1184 20.1982 38.2299 22.2799 40.8257 22.2799C43.4215 22.2799 45.533 20.1982 45.533 17.6399C45.533 15.0817 43.4215 13 40.8257 13Z",
  fill: "#606770"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8257 22.067C43.3061 22.067 45.3169 20.085 45.3169 17.6401C45.3169 15.1951 43.3061 13.2131 40.8257 13.2131C38.3453 13.2131 36.3345 15.1951 36.3345 17.6401C36.3345 20.085 38.3453 22.067 40.8257 22.067Z",
  fill: "#A0A1A7"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8257 13.2421C43.2859 13.2421 45.2875 15.2154 45.2875 17.64C45.2875 20.0646 43.2859 22.038 40.8257 22.038C38.3654 22.038 36.3639 20.0646 36.3639 17.64C36.3639 15.2154 38.3654 13.2421 40.8257 13.2421ZM40.8257 13.1851C38.3294 13.1851 36.306 15.1799 36.306 17.6409C36.306 20.102 38.3294 22.0968 40.8257 22.0968C43.322 22.0968 45.3453 20.102 45.3453 17.6409C45.3453 15.1799 43.322 13.1851 40.8257 13.1851Z",
  fill: "#606770"
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5605 13.4279L39.4989 13.4317C39.3094 13.47 39.1776 13.6307 39.1928 13.8222L39.2032 13.883L39.1994 13.8792L39.8467 16.3674L39.8676 16.4216C39.9311 16.5505 40.005 16.6 40.1433 16.6355L40.2049 16.6393V16.643H41.4483V16.6393L41.5099 16.6355C41.6237 16.6122 41.745 16.5328 41.7857 16.4216L41.8066 16.3636L41.8104 16.3674L42.451 13.8792L42.4614 13.8213C42.4757 13.6307 42.3439 13.469 42.1553 13.4307L42.0937 13.427H42.0909H39.5595H39.5624L39.5605 13.4279Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8257 18.5108C41.3114 18.5108 41.7052 18.1231 41.7052 17.6447C41.7052 17.1663 41.3114 16.7786 40.8257 16.7786C40.34 16.7786 39.9462 17.1663 39.9462 17.6447C39.9462 18.1231 40.34 18.5108 40.8257 18.5108Z",
  fill: "#606770",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  d: "M37.4983 20.5449L37.5286 20.5982C37.6461 20.7496 37.8499 20.7963 38.0186 20.701L38.0697 20.6655L38.0678 20.6701L40.0599 19.0135L40.1007 18.9715C40.1907 18.8594 40.204 18.7725 40.1765 18.6342L40.1528 18.5781L40.1557 18.5763L39.6155 17.4728L39.6126 17.4747L39.5823 17.4214C39.5112 17.3308 39.3861 17.257 39.2667 17.2701L39.2051 17.2766L39.207 17.2719L36.6558 17.7849L36.5989 17.8008C36.4179 17.8708 36.3288 18.0577 36.3752 18.2427L36.3989 18.2988V18.3016L37.5011 20.5487V20.5459L37.4983 20.5449Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1531 20.5449L44.1228 20.5982C44.0053 20.7496 43.8015 20.7963 43.6328 20.701L43.5816 20.6655L43.5835 20.6701L41.5914 19.0135L41.5507 18.9715C41.4607 18.8594 41.4474 18.7725 41.4749 18.6342L41.4986 18.5781L41.4957 18.5763L42.0359 17.4728L42.0388 17.4747L42.0691 17.4214C42.1402 17.3308 42.2653 17.257 42.3847 17.2701L42.4463 17.2766L42.4444 17.2719L44.9956 17.7849L45.0525 17.8008C45.2335 17.8708 45.3226 18.0577 45.2761 18.2427L45.2525 18.2988V18.3016L44.1503 20.5487V20.5459L44.1531 20.5449Z",
  fill: "#CFD1D3",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3866 18.1873H33.8534V22.7627H36.3866V18.1873Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3866 17.7202V17.7145C36.3828 17.5548 36.3335 17.4015 36.2274 17.3062L36.2208 17.2997C35.9402 17.0465 35.5962 16.9073 35.2465 16.9082H34.9925C34.6428 16.9082 34.2997 17.0465 34.0183 17.2997L34.0116 17.3062C33.9064 17.4015 33.8572 17.5548 33.8524 17.7145V17.7286V18.1864H36.3857V17.7202H36.3866Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M45.787 12.6206H36.234C35.2958 12.6206 34.5281 13.3774 34.5281 14.3024V18.734C34.5281 19.659 34.9707 20.4158 35.5128 20.4158H36.4975",
  stroke: "#AC6C32",
  strokeWidth: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M45.8315 13.1719H37.2253C36.2871 13.1719 35.5194 13.9287 35.5194 14.8537V16.8588",
  stroke: "#AC6C32",
  strokeWidth: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8491 18.8228H36.4075C36.3698 18.8228 36.3392 18.8529 36.3392 18.89V20.6699C36.3392 20.7071 36.3698 20.7372 36.4075 20.7372H36.8491C36.8868 20.7372 36.9173 20.7071 36.9173 20.6699V18.89C36.9173 18.8529 36.8868 18.8228 36.8491 18.8228Z",
  fill: "#C6C9CB"
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8491 18.8228H36.4075C36.3698 18.8228 36.3392 18.8529 36.3392 18.89V20.6699C36.3392 20.7071 36.3698 20.7372 36.4075 20.7372H36.8491C36.8868 20.7372 36.9173 20.7071 36.9173 20.6699V18.89C36.9173 18.8529 36.8868 18.8228 36.8491 18.8228Z",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9596 21.752H43.1552C42.8987 21.752 42.6908 21.9567 42.6908 22.2093C42.6908 22.4619 42.8987 22.6667 43.1552 22.6667H44.9596C45.2161 22.6667 45.424 22.4619 45.424 22.2093C45.424 21.9567 45.2161 21.752 44.9596 21.752Z",
  fill: "#C6C9CB",
  stroke: "#606770",
  strokeWidth: 0.05,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M47.4559 22.7068H33.5198V23.1067H47.4559V22.7068Z",
  fill: "#434244",
  stroke: "#434244",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M36.2198 12.0142V22.7133",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  d: "M38.5616 12.0142V22.7133",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  d: "M40.9034 12.0142V22.7133",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref206 = /*#__PURE__*/React.createElement("path", {
  d: "M43.2452 12.0142V22.7133",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 12.5056H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref208 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 12.7756H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref209 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 13.0447H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 13.3147H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 13.5847H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 13.8547H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 14.1248H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 14.3948H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 14.6648H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 14.9341H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 15.2041H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 15.4741H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref219 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 15.7441H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref220 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 16.0142H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref221 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 16.2842H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 16.5532H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref223 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 16.8232H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 17.0933H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 17.3633H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 17.6333H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 17.9033H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 18.1733H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 18.4424H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref230 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 18.7124H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref231 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 18.9824H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref232 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 19.2524H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref233 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 19.5225H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref234 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 19.7925H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref235 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 20.0625H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref236 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 20.3318H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref237 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 20.6018H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref238 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 20.8718H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref239 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 21.1418H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref240 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 21.4119H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref241 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 21.6819H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref242 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 21.9509H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref243 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 22.2209H45.5955",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref244 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 12.2356H45.6164",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref245 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8486 22.491H45.6164",
  stroke: "#606770",
  strokeWidth: 0.01,
  strokeMiterlimit: 10
});

var _ref246 = /*#__PURE__*/React.createElement("path", {
  d: "M47.4559 11.6208H33.5198V12.0077H47.4559V11.6208Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref247 = /*#__PURE__*/React.createElement("path", {
  d: "M47.6454 0.190186H45.6439V23.1414H47.6454V0.190186Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
});

var _ref248 = /*#__PURE__*/React.createElement("path", {
  d: "M0.711866 0.155518H0.318565V23.1413H0.711866V0.155518Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
});

var _ref249 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6508 0.155518H14.2575V23.1413H14.6508V0.155518Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
});

var _ref250 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7994 0.155518H33.4061V23.1413H33.7994V0.155518Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref251 = /*#__PURE__*/React.createElement("path", {
  d: "M47.6814 0.155518H0.354576V0.54327H47.6814V0.155518Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
});

var _ref252 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4004 1.03003H14.6357V22.4732H33.4004V1.03003Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
});

var _ref253 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2312 1.03003H23.8048V22.4732H24.2312V1.03003Z",
  fill: "#B7B7B1",
  stroke: "#93948F",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
});

var _ref254 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7871 11.0518H16.6694V12.4514H21.7871V11.0518Z",
  fill: "#023171"
});

var _ref255 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5232 12.0795H18.9269V11.9711H18.6435V11.8029H18.9013V11.6945H18.6435V11.532H18.9269V11.4236H18.5232V12.0795Z",
  fill: "white"
});

var _ref256 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2925 12.0795H20.6963V11.9711H20.4129V11.8029H20.6716V11.6945H20.4129V11.532H20.6963V11.4236H20.2925V12.0795Z",
  fill: "white"
});

var _ref257 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2539 11.4236H19.1344V12.0795H19.5259V11.9711H19.2539V11.4236Z",
  fill: "white"
});

var _ref258 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8339 11.4236H19.7135V12.0795H20.1049V11.9711H19.8339V11.4236Z",
  fill: "white"
});

var _ref259 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3423 11.8254L17.1651 11.4236H17.0485V12.0795H17.1651V11.6871L17.2911 11.9674H17.3935L17.5205 11.6871V12.0795H17.6361V11.4236H17.5205L17.3423 11.8254Z",
  fill: "white"
});

var _ref260 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2763 11.816C21.3265 11.7955 21.3625 11.7459 21.3625 11.6889V11.5619C21.3625 11.4862 21.3 11.4236 21.2223 11.4236H20.9038V12.0795H21.0232V11.8263H21.1493L21.2753 12.0795H21.4071L21.2753 11.816H21.2763ZM21.2422 11.6628C21.2422 11.6936 21.2175 11.7179 21.1862 11.7179H21.0242V11.532H21.1862C21.2175 11.532 21.2422 11.5563 21.2422 11.5871V11.6628Z",
  fill: "white"
});

var _ref261 = /*#__PURE__*/React.createElement("path", {
  d: "M18.181 11.9076C18.181 11.9431 18.1517 11.9711 18.1166 11.9711H18.0427C18.0067 11.9711 17.9782 11.9421 17.9782 11.9076V11.4236H17.8588V11.9337C17.8588 12.0141 17.9252 12.0795 18.0067 12.0795H18.1536C18.236 12.0795 18.3024 12.0141 18.3024 11.9328V11.4236H18.1829V11.9076H18.181Z",
  fill: "white"
});

var _ref262 = /*#__PURE__*/React.createElement("path", {
  d: "M31.3666 11.0518H26.2489V12.4514H31.3666V11.0518Z",
  fill: "#023171"
});

var _ref263 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1027 12.0795H28.5064V11.9711H28.223V11.8029H28.4817V11.6945H28.223V11.532H28.5064V11.4236H28.1027V12.0795Z",
  fill: "white"
});

var _ref264 = /*#__PURE__*/React.createElement("path", {
  d: "M29.873 12.0795H30.2758V11.9711H29.9924V11.8029H30.2511V11.6945H29.9924V11.532H30.2758V11.4236H29.873V12.0795Z",
  fill: "white"
});

var _ref265 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8333 11.4236H28.7139V12.0795H29.1053V11.9711H28.8333V11.4236Z",
  fill: "white"
});

var _ref266 = /*#__PURE__*/React.createElement("path", {
  d: "M29.4133 11.4236H29.293V12.0795H29.6844V11.9711H29.4133V11.4236Z",
  fill: "white"
});

var _ref267 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9218 11.8254L26.7446 11.4236H26.628V12.0795H26.7446V11.6871L26.8706 11.9674H26.973L27.1 11.6871V12.0795H27.2156V11.4236H27.1L26.9218 11.8254Z",
  fill: "white"
});

var _ref268 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8567 11.816C30.9069 11.7955 30.9429 11.7459 30.9429 11.6889V11.5619C30.9429 11.4862 30.8804 11.4236 30.8027 11.4236H30.4843V12.0795H30.6037V11.8263H30.7297L30.8558 12.0795H30.9875L30.8558 11.816H30.8567ZM30.8226 11.6628C30.8226 11.6936 30.7979 11.7179 30.7667 11.7179H30.6046V11.532H30.7667C30.7979 11.532 30.8226 11.5563 30.8226 11.5871V11.6628Z",
  fill: "white"
});

var _ref269 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7605 11.9076C27.7605 11.9431 27.7312 11.9711 27.6961 11.9711H27.6222C27.5862 11.9711 27.5577 11.9421 27.5577 11.9076V11.4236H27.4383V11.9337C27.4383 12.0141 27.5046 12.0795 27.5862 12.0795H27.733C27.8155 12.0795 27.8818 12.0141 27.8818 11.9328V11.4236H27.7624V11.9076H27.7605Z",
  fill: "white"
});

var SvgMaxximizer = function SvgMaxximizer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 25,
    viewBox: "0 0 48 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaxximizer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Maxximizer.1ae250ad.svg";
export { ForwardRef as ReactComponent };